import { PageContainer, ProTable } from '@ant-design/pro-components';
import { queryTraceAccountLogs } from '../services/trace';

const columns = [
  {
    title: '组织ID',
    dataIndex: 'organizationId',
    copyable: true,
  },
  {
    title: '账号类型',
    dataIndex: 'accountType',
  },
  {
    title: '平台',
    dataIndex: 'platform',
  },
  {
    title: '账号ID',
    dataIndex: 'accountId',
    copyable: true,
  },
  {
    title: '账号名称',
    dataIndex: 'name',
  },
  {
    title: '粉丝数',
    dataIndex: 'followerCount',
    valueType: 'digit',
    search: false,
  },
  {
    title: '获赞数',
    dataIndex: 'likeCount',
    valueType: 'digit',
    search: false,
  },
  {
    title: '收藏数',
    dataIndex: 'collectCount',
    valueType: 'digit',
    search: false,
  },
  {
    title: '作品数',
    dataIndex: 'contentCount',
    valueType: 'digit',
    search: false,
  },
  {
    title: '记录时间',
    dataIndex: 'createdAt',
    valueType: 'dateTime',
    search: false,
  },
];

const AccountLogs = () => (
  <PageContainer content="厂商管理员在这里查看账号维度的监测日志。">
    <ProTable
      rowKey="id"
      headerTitle="账号日志"
      request={queryTraceAccountLogs}
      columns={columns}
      search={{
        labelWidth: 96,
      }}
      scroll={{
        x: 'max-content',
      }}
    />
  </PageContainer>
);

export default AccountLogs;
